export const formatFiltersForRequest = (
  filters: FiltersDto | undefined
): string => {
  if (!filters) return ''

  return Object.entries(filters)
    .map(([key, values]) => values.map((value) => `&${key}=${value}`).join(''))
    .join('')
}
